module.exports = __webpack_public_path__ + "img/emoji.d3a0ac60.png";